import {
	CardContent,
	Grid,
	Card,
	Typography,
	TextField,
	Button,
	Dialog,
	useTheme,
	useMediaQuery,
	DialogTitle,
	DialogContent,
	DialogActions,
	DialogContentText,
} from "@material-ui/core";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "./LoginPage.css";
import { UserContext } from "../../contexts/UserContext";
import { useHistory } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import { detect } from "detect-browser";

export default function LoginPage() {
	const [phone, setPhone] = useState("");
	const [password, setPassword] = useState("");

	const [loading, setLoading] = useState(true);
	const [btnLoading, setBtnLoading] = useState(false);
	const [error, setError] = useState("");
	const [loginBlocked, setLoginBlocked] = useState(false);

	const { register, handleSubmit, errors } = useForm();

	const { setLoginTrue, isLoggedIn } = useContext(UserContext);
	const history = useHistory();

	const [open, setOpen] = React.useState(true);
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
	const handleClose = () => {
		setOpen(false);
	};

	const submit = async () => {
		if (loginBlocked) {
			return;
		}
		setError("");
		setBtnLoading(true);
		const data = {
			phone,
			password,
		};

		const url = `${process.env.REACT_APP_BACKEND_URL}/user/login`;

		try {
			await axios.post(url, data).then((res) => {
				// console.log(res);
				setLoginTrue(res.data.userDetails);
				localStorage.setItem("token", res.data.token);
				history.replace("/dashboard");
			});
		} catch (error) {
			// console.log(error);
			setBtnLoading(false);
			setError("Check your credentials and try again.");
		}
	};

	useEffect(() => {
		const browser = detect();
		if (browser && browser.name === "safari") {
			setLoginBlocked(true);
			setError(
				"Aapka browser supported nahi hai! Test dene ke liye Google Chrome, Brave ya Mozilla Firefox use karein."
			);
		}
	}, []);

	useEffect(() => {
		if (isLoggedIn) {
			history.replace("/dashboard");
		} else {
			setLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoggedIn]);

	if (loading) {
		return <Loading />;
	}

	return (
		<div className="login-page">
			<Card className="login-card">
				<CardContent className="">
					<form onSubmit={handleSubmit(submit)} id="login-form">
						<Grid container spacing={2} className="">
							<Grid item xs={12}>
								<Typography
									gutterBottom
									variant="h4"
									style={{
										fontWeight: "bold",
										marginBottom: "5%",
									}}
								>
									Login to Attempt Test
								</Typography>
							</Grid>
							<Grid item xs={12}>
								<TextField
									inputRef={register({ required: true })}
									name="phone"
									label="Phone *"
									placeholder="9876543210"
									variant="outlined"
									type="number"
									className="form-input"
									onChange={(e) => setPhone("+91" + e.target.value)}
									error={errors.phone ? true : false}
									helperText={errors.phone && "Phone is required"}
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									inputRef={register({ required: true })}
									name="password"
									label="Password *"
									variant="outlined"
									type="password"
									className="form-input"
									onChange={(e) => setPassword(e.target.value)}
									error={errors.password ? true : false}
									helperText={errors.password && "Password is required"}
								/>
							</Grid>
							<Grid item xs={12} className="btn-grid"></Grid>
						</Grid>

						<Button
							variant="contained"
							type="submit"
							form="login-form"
							color="secondary"
							className="login-btn"
							disabled={btnLoading || loginBlocked}
							// disabled={true}
						>
							{btnLoading ? "Logging In..." : "Login"}
						</Button>
						<br />
						<br />
						<Typography variant="h6" color="secondary">
							{error}{" "}
						</Typography>
					</form>
				</CardContent>
			</Card>
			<Dialog fullScreen={fullScreen} open={open} onClose={handleClose} maxWidth="md">
				<DialogTitle>
					{"WELCOME TO JRT."}
					<br /> {"PLEASE READ THESE INSTRUCTIONS CAREFULLY BEFORE ATTEMPTING THE TEST."}
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						<ol>
							<li>
								{"The login id and password for the JRT are:"}
								<br />
								<strong>{"Login id: <your phone number>"}</strong>
								<br />
								<strong>{"Password: <JRT dashboard password>"}</strong>
							</li>
							<li>
								{
									"Once you login, carefully read the instructions regarding the exam."
								}
							</li>
							<li>
								{
									"The exam will have audio based questions so please use headphones with a good microphone."
								}
							</li>
							<li>
								{
									"You are requested to stay on the examination link provided and do not open any other Tab / window on your screen. This will lead to disqualification and the examination link will expire at the very moment."
								}
							</li>
							<li>
								{
									"The examination will be conducted in an online proctored mode.The candidate can take the test from the safe and secure environment of his / her home, with a desktop / laptop(with a microphone) and an internet connection(un - interrupted internet speed is desirable)"
								}
							</li>
						</ol>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary" variant="outlined">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
